import React from "react"

import { Button as JoyButton} from "@mui/joy";
import { Icon } from '../../assets';

const Button = ({label, icon, family, disabled, loading, variant, size = "regular", onClick, className, tooltip, children, customSize, fullWidth, title, form, type}) => {

    className = (((typeof className != typeof undefined) ? className : '') + " input-button " + size).trim();
    if (!label && !children) className += " iconic";

    return (
        <JoyButton
            type={type}
            form={form}
            fullWidth={fullWidth}
            size={customSize}
            variant={variant}
            onClick={onClick}
            disabled={disabled}
            loading={loading}
            className={className}
            startDecorator={(icon) ? (
                <Icon icon={icon} family={family}/>
            ) : (
                <></>
            )}
            title={title}
        >
            {(label) ? label : children}
            {(tooltip) && <span className="tooltip">{tooltip}</span>}
        </JoyButton>
    );
};


export default Button;
